import React, { useState, useEffect, useContext, Fragment, useCallback } from 'react';
import { Input, Table, Avatar, message, Modal, Tag, Button, Tooltip, Progress } from "antd";
import { PlusOutlined, SettingTwoTone, ExclamationCircleOutlined, FileTextOutlined, ApiOutlined, BugOutlined, CodeOutlined, ToolOutlined, ExperimentOutlined, RobotOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router';
import WscDictMapping from "@/component/dictmapping";
import useWscTableList from '@/component/UseWscTableList';
import useWscCustomFormModal from '@/component/UseWscCustomForm';
import useWscCustomColumns from '@/component/UseWscCustomColumns';
import useRequest from '@/utils/useRequest';
import { useCommonStore } from "@/store/useCommonStore";
import ColumnSettings from '@/component/ColumnSettings';
import AppCard from '@/components/AppCard';
import _ from "lodash";

const { Search } = Input;

const initParams = {
  pagination: {
    current: 1,
    pageSize: 5
  },
  filters: {
  },
  sorter: null
};


const ProjectList = (props) => {
  const { request } = useRequest();
  const navigate = useNavigate(); // Add this hook
  const { showDynamicModal, hide, WscCustomFormModal } = useWscCustomFormModal();
  const { list, isLoading, pagination, setPage, setFilter, filters, setSorter, Refresh } = useWscTableList({
    //appid:"crttcserver",
    url: "/api/v2/private/youtrack/project/search", initParams: initParams
  });

  const { Refresh: refreshColumns, colsettings } = useWscCustomColumns({ key: "project" });
  const [columns, setColumns] = useState([]);
  useEffect(() => {
    if (colsettings) {

      let cols = colsettings?.filter(item => item.visible).concat(ExtendColumns);
      // 添加任务类型图标映射
      const taskTypeIcons = {
        requirement: <FileTextOutlined style={{ color: '#1890ff' }} />,
        model: <ToolOutlined style={{ color: '#722ed1' }} />,
        api: <ApiOutlined style={{ color: '#13c2c2' }} />,
        prototype: <CodeOutlined style={{ color: '#eb2f96' }} />,
        ui: <ToolOutlined style={{ color: '#fa8c16' }} />,
        frontend: <CodeOutlined style={{ color: '#a0d911' }} />,
        whiteTest: <ExperimentOutlined style={{ color: '#52c41a' }} />,
        blackTest: <RobotOutlined style={{ color: '#595959' }} />,
        bugfix: <BugOutlined style={{ color: '#f5222d' }} />
      };
      // 渲染任务量图标函数
      const renderTaskIcons = (tasks) => {
        if (!tasks) return null;

        return (
          <div className="flex flex-wrap gap-2">
            {Object.entries(tasks).map(([type, count]) => {
              if (count > 0) {
                let icon;
                let label;

                switch (type) {
                  case 'requirement':
                    icon = taskTypeIcons.requirement;
                    label = '需求分析';
                    break;
                  case 'model':
                    icon = taskTypeIcons.model;
                    label = '模型设计';
                    break;
                  case 'api':
                    icon = taskTypeIcons.api;
                    label = 'API接口';
                    break;
                  case 'prototype':
                    icon = taskTypeIcons.prototype;
                    label = '原型设计';
                    break;
                  case 'ui':
                    icon = taskTypeIcons.ui;
                    label = 'UI设计';
                    break;
                  case 'frontend':
                    icon = taskTypeIcons.frontend;
                    label = '前端开发';
                    break;
                  case 'whiteTest':
                    icon = taskTypeIcons.whiteTest;
                    label = '白盒测试';
                    break;
                  case 'blackTest':
                    icon = taskTypeIcons.blackTest;
                    label = '黑盒测试';
                    break;
                  case 'bugfix':
                    icon = taskTypeIcons.bugfix;
                    label = 'BUG修复';
                    break;
                  default:
                    icon = <FileTextOutlined />;
                    label = type;
                }

                return (
                  <Tooltip key={type} title={`${label}: ${count}`}>
                    <div className="flex items-center bg-gray-50 rounded-md px-2 py-1">
                      {icon}
                      <span className="ml-1">{count}</span>
                    </div>
                  </Tooltip>
                );
              }
              return null;
            }).filter(Boolean)}
          </div>
        );
      };
      // 渲染任务进度函数
      const renderTaskProgress = (tasks) => {
        if (!tasks) return null;

        const total = Object.values(tasks).reduce((sum, count) => sum + count, 0);
        const completed = tasks.completed || 0;
        const percent = total > 0 ? Math.round((completed / total) * 100) : 0;

        return (
          <div className="mt-2">
            <Progress percent={percent} size="small" />
          </div>
        );
      };
      if (colsettings) {
        let cols = colsettings?.filter(item => item.visible).concat(ExtendColumns);

        // 添加任务量列
        const taskColumn = {
          title: '任务分布',
          dataIndex: 'tasks',
          key: 'tasks',
          width: 280,
          render: (tasks, record) => (
            <div>
              {renderTaskIcons(record)}
              {renderTaskProgress(record)}
            </div>
          )
        };

        cols.push(taskColumn);

        // let col3 = cols.find(item => item.dataIndex == "leader");
        // if (col3) {
        //   col3.render = (leader) => {
        //     return leader.name;
        //   };
        // }

        //setColumns(cols);
      }
      // let col3 = cols.find(item => item.dataIndex == "leader");
      // if (col3) {
      //   col3.render = (leader) => {
      //     return leader.name;
      //   };
      // }

      setColumns(cols);
    }
  }, [colsettings]);

  const ExtendColumns = [
    {
      title: <div>操作 <ColumnSettings topic="project" colsettings={colsettings} list={list} onFinish={refreshColumns} /></div>,
      dataIndex: 'id',
      key: 'id',
      render: (id, record) => {
        // console.log('Id, item, idx', Id, idx, item)
        return (
          <Fragment>
            <Button
              //mode={"hide"} 
              type='link' onClick={async () => {
                //导航到pipeline详情页
                navigate(`/pipeline/${record.Id}`);
              }}>查看</Button>
            <Button resId={76}
              //mode={"hide"}
              type='link' onClick={async () => {
                showDynamicModal(208, { ProjectId:record.Id });
              }}>新增应用</Button>
          </Fragment>
        );
      },
    },
  ];
  
  const handleTableChange = (pagination, _filters, sorter) => {
    setPage(pagination.current);
    setFilter({ ...filters, ..._filters });
    setSorter(sorter);
  }
  
  // 自定义表格组件，使每行数据显示为两行
  const customComponents = {
    body: {
      row: (props) => {
        const { children, ...restProps } = props;
        const record = props['data-row-key'] && list.find(item => item.Id === props['data-row-key']);
        
        // 创建两行：第一行是原始数据，第二行是合并的单元格
        return (
          <>
            <tr {...restProps}>{children}</tr>
            <tr>
              <td colSpan={columns.length} className="bg-gray-50 p-3">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                  {record?.Applications?.map((app, index) => (
                    <AppCard 
                      key={index} 
                      app={app} 
                      showDynamicModal={showDynamicModal} 
                      onRefresh={Refresh} 
                    />
                  ))}
                </div>
                {record?.ManagerId && (
                  <div className="mt-3 text-gray-600">
                    <span className="font-medium">负责人ID: </span>{record.ManagerId}
                  </div>
                )}
              </td>
            </tr>
          </>
        );
      }
    }
  };
  
  return (
    <div style={{ maxHeight: 'calc(100vh - 120px)', overflowY: 'scroll' }} className='bg-white pl-4 pb-4'>
      <div className="flex flex-row mb-4 items-center justify-between">
        <div className="flex flex-row items-center mt-4">
          <span className="text-base text-gray-800 font-bold mr-4">查询</span>
          <div>
            <Search placeholder="请输入查询内容" onSearch={(val) => {
              setFilter({ ...filters, keywords: val });
            }} enterButton />
          </div>
        </div>
        <Button className='mr-4 mt-4' onClick={() => {
          setFilter(initParams.filters);
          setPage(1);
        }}>
          重置
        </Button>
      </div>
      <Button resId={74}
        //mode={"hide"}
        className="mb-4" type="primary" icon={<PlusOutlined />} onClick={() => {
          showDynamicModal(208, {});
        }}>
        新增
      </Button>
        <Table
          className="w-full h-full mr-4"
          rowKey={"Id"}
          loading={isLoading}
          bordered
          dataSource={list}
          columns={columns}
          pagination={pagination}
          onChange={handleTableChange}
          size="small"
          components={customComponents}
        />
      <WscCustomFormModal formId={208} OnPayload={(form, name, payload) => {
        if (name == "OK") {
          if (payload.apiresult?.success == false) {
            Modal.error({ content: payload.apiresult.message });
            return;
          } else {
            message.success(payload.apiresult?.message);
            hide(208);
            Refresh();
            return;
          }
        }
        if (name == "Cancel") {
          hide(208);
          return;
        }
      }
      }
      />
      <WscCustomFormModal formId={209} OnPayload={(form, name, payload) => {
        if (name == "OK") {
          if (payload.apiresult?.success == false) {
            Modal.error({ content: payload.apiresult.message });
            return;
          } else {
            message.success(payload.apiresult?.message);
            hide(209);
            Refresh();
            return;
          }
        }
        if (name == "Cancel") {
          hide(209);
          return;
        }
      }
      }
      />
      <WscCustomFormModal formId={210} OnPayload={(form, name, payload) => {
        if (name == "OK") {
          if (payload.apiresult?.success == false) {
            Modal.error({ content: payload.apiresult.message });
            return;
          } else {
            message.success(payload.apiresult?.message);
            hide(210);
            Refresh();
            return;
          }
        }
        if (name == "Cancel") {
          hide(210);
          return;
        }
      }
      }
      />
    </div>
  );
}

export default ProjectList;